import React from 'react';

const FullScreenLoader = ({ message = "Chargement des données..." }) => (
  <div className="loader-screen" role="status" aria-live="polite">
    <div className="loader-orb">
      <span className="loader-ring r1" />
      <span className="loader-ring r2" />
      <span className="loader-core" />
    </div>
    <h2 className="loader-title">{message}</h2>
    <div className="loader-dots" aria-hidden="true"><i /><i /><i /></div>
  </div>
);

export default FullScreenLoader;
